import { render, staticRenderFns } from "./ConfigVersionSwitch.vue?vue&type=template&id=5ac32af9&"
import script from "./ConfigVersionSwitch.vue?vue&type=script&lang=ts&"
export * from "./ConfigVersionSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports